module.exports = __webpack_public_path__ + "static/media/space_jam3.260cce02.gif";